import { saveReturnUrl, useAuthentication } from '@src/features/auth';
import { useAPIClientBase } from '@src/shared/api';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate, useRouter } from '@tanstack/react-router';
import { useCallback } from 'react';

function useAPIClient() {
  const auth = useAuthentication();
  const navigate = useNavigate();
  const router = useRouter();
  const queryClient = useQueryClient();

  const handle401 = useCallback(() => {
    const returnUrl = saveReturnUrl(
      router.state.location.href,
      auth.credentials?.user?.id,
    );
    void navigate({
      to: '/auth/login',
      search: returnUrl === '/' ? {} : { redirect: returnUrl },
      replace: true,
    }).then(() => {
      queryClient.clear();
    });
  }, [auth.credentials?.user?.id, navigate, queryClient, router]);

  return useAPIClientBase({ auth, on401: handle401 });
}

export default useAPIClient;
